import React, { useCallback, useMemo } from 'react'

import { DropdownContext, DropdownContextValue, useDropdownContext } from './dropdownContext'

export type DropdownContextProviderProps = {
    children: React.ReactNode
    isOpen: boolean
    setIsOpen: (value: boolean) => void
}

export const DropdownContextProvider: React.FC<DropdownContextProviderProps> = ({
    children,
    isOpen,
    setIsOpen,
}) => {
    const parentContext = useDropdownContext()

    const rootContext: DropdownContextValue | null = useMemo(() => {
        let parent = parentContext
        while (parent?.parentContext) {
            parent = parent.parentContext
        }

        return parent
    }, [parentContext])

    const closeRoot = useCallback(() => {
        if (rootContext) {
            rootContext.setIsOpen(false)
        }
    }, [rootContext])

    return (
        <DropdownContext.Provider
            value={{
                isOpen,
                setIsOpen,
                parentContext,
                closeRoot,
            }}
        >
            {children}
        </DropdownContext.Provider>
    )
}
